<template>
  <card v-show="loading" class="download-widget" dis-hover>
    <spin size="large" />
    <div class="download-widget__title ms-text">
      Идет скачивание документов... ({{ loaded }} МБ)
    </div>
  </card>
</template>

<script>
export default {
  computed: {
    loading () {
      return this.$store.state.downloading.loading
    },
    loaded () {
      return this.$store.state.downloading.loaded
    }
  }
}
</script>

<style lang="less">
.download-widget {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.3);
  z-index: 1000;

  .ivu-card-body {
    display: flex;
    align-items: center;
  }

  &__title {
    margin-left: 16px;
  }
}
</style>
